'use client';

import ClassService from '@/lib/services/class_services';
import { useLocalParticipant } from '@livekit/components-react';
import { useEffect, useRef } from 'react';

type TokenMetadata = {
  user_type?: string;
  is_moderator?: boolean;
  admitted?: boolean;
  chat_muted?: boolean;
  level_id?: number;
  level_name?: string;
  subject_id?: number;
  online_class_id?: number;
};

export default function Log() {
  const participant = useLocalParticipant();
  const sent = useRef(false);

  useEffect(() => {
    function log() {
      if (!participant.localParticipant.metadata) return;
      const metadata = JSON.parse(participant.localParticipant.metadata) as TokenMetadata;
      ClassService().activity({
        online_class_id: metadata.online_class_id!,
        mode: 'JOIN_GENIECLASS',
        subject_id: metadata.subject_id!,
        device_type: 'DEVICE_TYPE_MEET',
      });
      sent.current = true;
    }
    if (!sent.current) log();
  }, [participant]);

  return <></>;
}
